import { components, MenuListProps, GroupBase } from "react-select";
import classNames from "classnames";

type MenuListOverrideProps<OptionType> = MenuListProps<OptionType, false, GroupBase<OptionType>> & {
	stableClassName?: string;
	stableTestId?: string;
};

const MenuList = <OptionType,>({
	children,
	stableClassName,
	stableTestId,
	...props
}: MenuListOverrideProps<OptionType>) => (
	<components.MenuList
		className={classNames("react-select-field-menu-list", stableClassName)}
		{...props}
	>
		<div className="react-select-field-menu-list__container" data-testid={stableTestId}>
			{children}
		</div>
	</components.MenuList>
);

export { MenuList };
